import { API_PDC_URL_V2 } from "../../../config";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";
import { callWithRetry } from "../../services/callWithRetry";

export const recipientsConstants = {
  CLEAR_SEARCHED_RECIPIENTS: "CLEAR_SEARCHED_RECIPIENTS",
  LOAD_RECIPIENTS_START: "LOAD_RECIPIENTS_START",
  LOAD_RECIPIENTS_SUCCESS: "LOAD_RECIPIENTS_SUCCESS",
  LOAD_SEARCHED_RECIPIENTS_SUCCESS: "LOAD_SEARCHED_RECIPIENTS_SUCCESS",
  LOAD_RECIPIENTS_ERROR: "LOAD_RECIPIENTS_ERROR",
  LOAD_RECIPIENTS_RESET: "LOAD_RECIPIENTS_RESET"
};

export function clearSearched() {
  return (dispatch) => {
    dispatch({
      type: recipientsConstants.CLEAR_SEARCHED_RECIPIENTS
    });
  };
}
export function loadRecipients(
  searchTerm = "", companiesList = null, page = 0, size = 40
) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const main = getState().main;
    const accountantID = main.accountantIdSelected;

    return new Promise((resolve, reject) => {
      let isAppend = page > 0;

      if (searchTerm === "" && !isAppend)
        dispatch({
          type: recipientsConstants.LOAD_RECIPIENTS_START
        });

      const accountantGetParam = accountantID ? `&accountantId=${accountantID}` : "";
      let request = {
        method: "get",
        url: `${API_PDC_URL_V2}/anagrafica/companies?fullText=${searchTerm}&page=${page}&size=${size}${accountantGetParam}`,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((res) => {
          if (res.status === 200) {
            // se non ho risultati ma ho fatto ricerca allora non caricare nulla
            if (searchTerm !== "") {
              dispatch({
                type: recipientsConstants.LOAD_SEARCHED_RECIPIENTS_SUCCESS,
                payload: {
                  data: res.data,
                  companiesList: companiesList,
                  hasMoreItems: res.data.hasMoreItems,
                  page: page
                }
              });
              resolve([]);
            } else {
              dispatch({
                type: recipientsConstants.LOAD_RECIPIENTS_SUCCESS,
                payload: {
                  result: res.data.items.filter((el) => {
                    return el.classifier !== "STUDIO";
                  }),
                  companiesList: companiesList,
                  hasMoreItems: res.data.hasMoreItems,
                  isAppend: isAppend,
                  page: page
                }
              });
              resolve(res.data.items.filter((el) => {
                return el.classifier !== "STUDIO";
              }));
            }
          } else {
            dispatch({
              type: recipientsConstants.LOAD_RECIPIENTS_ERROR,
              payload: res
            });
          }
        })
        .catch((err) => {
          dispatch({
            type: recipientsConstants.LOAD_RECIPIENTS_ERROR,
            payload: err
          });
          reject(err);
        });
    });
  };
}
